<template>
  <div class="addOrUpdataVideo">
    <div class="title">
      <span>视频管理</span>
      <span>></span>
      <span>{{ this.videoId ? '编辑视频' : '添加视频' }}</span>
      <el-button class="returnPre" @click="backVideoList">返回</el-button>
    </div>

    <div class="bt">
      <span>*</span>
      为必填项
    </div>
    <el-form class="form" label-width="96px" :rules="rules" :model="form" ref="formData">
      <el-form-item label="标题：" prop="title">
        <el-input v-model="form.title" placeholder="请填写标题" :disabled="see"></el-input>
      </el-form-item>
	  
	  <el-form-item label="上传封面" class="adverposi"  prop="image" >
	    <el-upload
	      class="avatar-uploader"
	      :action="uploadAction"
	      :show-file-list="false"
	      :on-success="imageHandleAvatarSuccess"
	      :before-upload="imageBeforeAvatarUpload"
	    >
	      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
	      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
	      <div slot="tip" class="el-upload__tip rihtDpi">配图显示到视频封面，上传图片不要超过2M</div>
	      <img
	        :src="require('../../../assets/image/delete_icon.png')"
	        alt
	        class="delete__icon"
	        @click="deleteImg"
	      />
	      <div class="adverpt">上传图片</div>
	    </el-upload>
	  </el-form-item>
	  
	  
	  <el-form-item label="上传时间" prop="uploadDate">
	    <el-date-picker
	      v-model="form.uploadDate"
	      type="datetime"
	      placeholder="选择上传时间"
	      :picker-options="pickerOptions"
		  value-format="yyyy-MM-dd HH:mm:ss"
	    ></el-date-picker>
	  </el-form-item>
	  

      <el-form-item  label="内容" prop="content">
       <div id="editor"></div>
      </el-form-item>
    </el-form>
    <div class="preservation">
      <el-button @click="saveVideoInfoBtn" :disabled="see">保存</el-button>
    </div>
  </div>
</template>
<script>
import E from "wangeditor";
export default {
  props: ["see", "videoId"],
  components: {
  },
  data() {
    return {
      editor: "",
	  // 图片上传路径
	  uploadAction: this.$http.adornUrl(`/fileupload/upload`),
	  imageUrl: "",
      form: {
        title: "",
		image:"",
		uploadDate:"",
        content: "",
      },
      rules: {
        title: [
			{ required: true, message: "标题不能为空", trigger: "blur" },
			{ max: 40,  message: '最大20个字符' }
		 ],
		image: [
          { required: true, message: "封面不能为空", trigger: "blur" }
        ],
		uploadDate: [
			{ required: true, message: "上传时间不能为空", trigger: "blur" },
		],
        content: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ]
      },
	  pickerOptions: {
	    disabledDate(time) {
	      return time.getTime() > Date.now();
	    },
	  },
    };
  },
  mounted() {
    this.initEditor();
    if (this.videoId) {
      this.getVideoInfo();
    }
  },
  methods: {
    initEditor() {
      this.editor = new E("#editor");
      // 隐藏网络图片，上传本地
      this.editor.customConfig.showLinkImg = false;
      this.editor.customConfig.uploadFileName = "file";
      this.editor.customConfig.uploadImgServer = this.uploadAction;
      let that = this;
      this.editor.customConfig.uploadImgHooks = {
        customInsert: function (insertImg, result, editor) {
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            insertImg(that.$http.adornUrl(result.data.url));
          } else {
            flavrShowByTime("上传失败", null, "danger");
          }
        },
      };
      this.editor.customConfig.uploadVideoServer = this.$http.adornUrl(
        `/fileupload/uploadVideo?token=${this.$cookie.get("token")}`
      );
      this.editor.customConfig.uploadVideoHooks = {
        customInsert: function (insertVideo, result, editor) {
          // insertVideo 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            insertVideo("http://10.165.5.36/" + result.data.url);
          } else {
            flavrShowByTime("上传失败", null, "danger");
          }
        },
        success: function success(xhr, editor, result) {
          // 视频上传并返回结果，视频插入成功之后触发
        },
      };


      this.editor.customConfig.onchange = (html) => {
        this.form.content = html;
      };
      this.editor.create();
      // this.editor.txt.html();
    },
	
	//----image--------开始
	// image上传成功
	imageHandleAvatarSuccess(res, file) {
	  this.imageUrl = URL.createObjectURL(file.raw);
	  this.form.image = res.data.url;
	},
	// image上传之前 
	imageBeforeAvatarUpload(file) {
	  // const isJPG = file.type === "image/jpeg";
	  // const isLt2M = file.size / 1024 / 1024 < 2;
	  // if (!isJPG) {
	  //   this.$message.error("上传头像图片只能是 JPG 格式!");
	  // }
	  // if (!isLt2M) {
	  //   this.$message.error("上传头像图片大小不能超过 2MB!");
	  // }
	  // return isJPG && isLt2M;
	},
	//image
	deleteImg(e) {
	  e.stopPropagation(); // 删除的时候不让触发添加图片的方法
	  this.imageUrl = "";
	},
	//----image--------结束
   //不会更新点击click不会+1
   getVideoInfo() {
	  this.$http({
	    url: "getImageVideoInfoOnlyView",
	    method: "post",
	    params: {
	      id: this.videoId,
	    },
	  }).then(({ data }) => {
	    let { code, imageVideoInfo } = data;
	    if (code === 0) {
			this.form.title = imageVideoInfo.title;
			this.form.image = imageVideoInfo.image;
			this.form.uploadDate = imageVideoInfo.uploadDate;
			this.form.content = imageVideoInfo.content;
			this.editor.txt.html(imageVideoInfo.content);
			
			this.imageUrl = this.$getSrc(imageVideoInfo.image);
	    }
	  }); 
   },

    // 返回视频管理
    backVideoList() {
      this.$emit("addUpdateStatus");
    },

    // 保存
    saveVideoInfoBtn() {
	//el=from ref=""	
      this.$refs["formData"].validate(valid => {
        if (valid) {
          this.$http
            .post(`${this.videoId ? 'updateAccountImageVideo' : 'saveAccountImageVideo'}`, {
              id: this.videoId ? this.videoId : "",
              title: this.form.title,
		      image: this.form.image,
			  uploadDate: this.form.uploadDate,
              content: this.form.content
            })
            .then(({ data }) => {
              let { code, msg } = data;
              if (code === 0) {
                this.$message({
                  message: `视频${this.videoId ? '修改' : '添加'}成功！`,
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$emit("addUpdateStatus");
                    this.$emit("getVideoList");
                  }
                });
              } else {
                this.$message.error(msg);
              }
            })
            .catch(err => console.log(err));
        }
      });
    }
  }
};
</script>
<style lang="scss">
.addOrUpdataVideo {
  .el-input__inner {
    height: 42px;
  }
  .quillWrapper {
    width: 624px;
    height: 385px;
    .ql-container {
      height: 74%;
    }
  }
}
</style>
<style lang="scss" scoped>
.addOrUpdataVideo {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 25px;
    span:first-child {
      cursor: pointer;
    }
    span:nth-child(2) {
      margin: 0 8px;
    }
  }
  .bt {
    width: 66px;
    height: 14px;
    line-height: 14px;
    float: right;
    color: #999999;
    margin-right: 30px;
    font-size: 14px;
    span {
      color: #ff6059;
    }
  }

  .form {
    margin-top: 60px;
    padding: 0 116px 0 84px;
    .el-input {
      width: 624px;
    }
  }
  .preservation {
    margin: 180px 0 43px 0;
    text-align: center;
    button {
      width: 160px;
      height: 50px;
      font-size: 18px;
      color: #ffffff;
      background-color: #143372;
    }
  }
  
  /*上传图片样式--------开始*/
  .adverposi {
    position: relative;
  }
  .avatar-uploader-icon {
    background-color: #e5e5ee;
  }
  .avatar-uploader .el-upload {
    position: static;
  }
  .adverpt {
    width: 150px;
    height: 38px;
    background-color: #727272;
    position: absolute;
    bottom: 2px;
    left: 0;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 38px;
  }
  .delete__icon {
    position: absolute;
    right: 481px;
    top: 6px;
    cursor: pointer;
  }
  .rihtDpi {
    float: right;
    margin: 125px 230px 0 0;
    color: #999999;
  }
  /*上传图片样式--------结束*/
  
  .mx-datepicker-popup {
    z-index: 3000000 !important; // 大于el-drawer的2000，但小于最大值9999
  }
}
</style>